import { storeToRefs } from "pinia";

import { DealActivityState } from "@/enums/dealActivity";
import { PipType } from "@/enums/pip";
import { DEFAULT_DEAL_ACTIVITY_OPTIONS } from "@/helpers/constants/deals";
import { useEmitter } from "@/hooks/common";
import { useLocalStorageSetting } from "@/hooks/options";
import { usePiPView } from "@/hooks/pip";
import { useCommunicationStore } from "@/stores/communication";
import useNotesStore from "@/stores/notes";

import type { CommunicationType } from "@/enums/communicationLogs";

export const useActivityModal = () => {
  const notesStore = useNotesStore();
  const communicationStore = useCommunicationStore();
  const dealActivityOptions = useLocalStorageSetting(
    "dealActivityOptions",
    DEFAULT_DEAL_ACTIVITY_OPTIONS
  );
  const { isPiPAvailable } = usePiPView();
  const emitter = useEmitter();

  const { dealActivityActiveTypes } = storeToRefs(communicationStore);

  const openActivityModal = ({
    model,
    activeTypes = [],
    isAllActivity = false,
  }: {
    model: { id?: string };
    activeTypes?: CommunicationType[];
    isAllActivity?: boolean;
  }) => {
    if (!model.id || isAllActivity) {
      return;
    }
    notesStore.activeNoteDealId = model.id;
    dealActivityActiveTypes.value = activeTypes;

    if (isPiPAvailable.value && dealActivityOptions.value.isPiPModeEnabled) {
      dealActivityOptions.value = {
        ...dealActivityOptions.value,
        state: DealActivityState.PiP,
      };
      emitter.emit("OPEN_PIP_VIEW", PipType.DealActivity);
      emitter.emit("UPDATE_PIP_DEAL", { setCurrentDeal: false });
      return;
    }

    dealActivityOptions.value = {
      ...dealActivityOptions.value,
      state: DealActivityState.Draggable,
    };
  };

  return {
    openActivityModal,
  };
};
